import React from "react";

import CreatableSelect from 'react-select/lib/Creatable';

import {ILabel, Label} from "./Label";


export const CreatableSelectLabeled : React.FC<Props> = (props : Props) : JSX.Element => {


    return (
            <div className="input-container">
                { props.label === undefined ?
                null : 
                <Label
                    label = {props.label}
                    isRequired = {props.isRequired}
                />
                }
                <CreatableSelect
                    value={props.value}
                    placeholder={props.placeholder}
                    onChange={props.onChange}
                    options={props.options}
                    isMulti={props.multi}
                />
            </div>
    )

}


interface Props {
    readonly onChange : React.ChangeEventHandler;
    readonly value : Array<FieldValue>;
    readonly options : Array<FieldValue>;
    readonly multi : boolean | undefined;
    readonly label : ILabel | undefined;
    readonly isRequired : boolean | undefined;
    readonly placeholder : string | undefined;
}

interface FieldValue {
    readonly value : string;
    readonly label : string;

}